// packages/web/src/components/GlobalCreate.tsx — R3: the app-wide "+" that
// opens the GLOBAL create menu (components/RecordEditor.tsx → every creatable
// type). Pinned top-right of the shell so a manual create is always one tap
// away, on every screen and every breakpoint — the manual-first baseline's
// front door. Deliberately quiet (ghost, hairline) so it never competes with
// the Knot (the auto-capture accelerator) or a screen's own content.
import { openCreateMenu } from '../lib/recordEditor';
import './GlobalCreate.css';

// MAIL-POLISH BRIEF addition (Huan, final, 2026-10-16) — this "+" is
// CONTEXTUAL on the cockpit (personal pack): the caller (App.tsx) picks
// what it does and says on the screen in view — Compose on Mail, New event
// on Calendar — and falls back to these two defaults (the global create
// menu, "Create a record") everywhere else, exactly as before this chunk.
// Every OTHER pack's GlobalCreate call site passes neither prop, so its
// behaviour is byte-identical to before.
export interface GlobalCreateProps {
  onClick?: () => void;
  ariaLabel?: string;
}

export function GlobalCreate({ onClick, ariaLabel }: GlobalCreateProps = {}) {
  return (
    <button
      type="button"
      class="global-create"
      onClick={onClick ?? openCreateMenu}
      aria-label={ariaLabel ?? 'Create a record'}
      data-testid="global-create"
    >
      <span aria-hidden="true">+</span>
    </button>
  );
}
